import template from './fuel_surcharges.all.html';
import controller from './fuel_surcharges.all.controller';
import './fuel_surcharges.all.scss';

let fuelSurchargesAllComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template,
  controller
};

export default fuelSurchargesAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/all/fuel_surcharges.all.component.js